import React, { useRef, forwardRef } from 'react';

import Video from 'react-scale/components/ui/video';
import Modal from 'react-scale/components/tailwind/Modal';
import showModal from 'react-scale/components/tailwind/Modal/showModal';

const VideoModal = ({ url, poster, smallButton, controls, blackButton, hideCloseButton }) => {
  const modal = showModal();
  const modalVideoRef = useRef(null);

  return (
    <div className="relative w-full text-center transition-transform duration-200 ease-in-out group">
      <VideoOverlay ref={modalVideoRef} url={url} hideCloseButton={hideCloseButton} {...modal} />
      <div className="relative w-full bg-gray-800 rounded-2xl">
        <Video
          url={url}
          poster={poster}
          smallButton={smallButton}
          controls={controls}
          blackButton={blackButton}
          onModalClick={modal.toggle}
        />
      </div>
    </div>
  );
};

const VideoOverlay = forwardRef(({ isShowing, close, time, url, hideCloseButton }, ref) => (
  <Modal
    isShowing={isShowing}
    hide={close}
    borderColor={false}
    contentClassName="w-[95vw] md:w-[80vw] lg:w-[70vw] backdrop-blur-xl bg-white rounded-2xl bg-opacity-[15%]"
    hideCloseButton={hideCloseButton}
  >
    <Video
      onReady={() => ref.current.seekTo(time, 'seconds')}
      ref={ref}
      url={url}
      controls
      playing
    />
  </Modal>
));

export default VideoModal;
